module.exports = __webpack_public_path__ + "static/media/waves.f14822c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements/waves.svg
// module id = 156
// module chunks = 0